const CARDS = [
  {
    id: 1,
    title: '香蕉视频 · 都市情感剧场',
    desc: '汇集香蕉视频平台最新都市情感大剧，涵盖甜蜜爱情与职场成长，每日更新热门剧集。',
    tag: '情感',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20movie%20still%20inspired%20composition%20with%20warm%20cinematic%20lighting%20and%20deep%20shadows%2C%20film%20noir%20mood%2C%20elegant%20composition%20with%20subtle%20golden%20accent%20tones%2C%20modern%20entertainment%20atmosphere%2C%20clean%20studio%20photography%20style%20on%20seamless%20warm%20gray%20background&width=600&height=400&seq=card-drama-01&orientation=landscape',
  },
  {
    id: 2,
    title: '糖豆视频 · 悬疑烧脑合集',
    desc: '糖豆视频高分悬疑剧集精选，层层反转烧脑不停，带你挑战智商极限的沉浸式观影体验。',
    tag: '悬疑',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20television%20drama%20inspired%20scene%20with%20warm%20amber%20and%20rose%20lighting%2C%20emotional%20storytelling%20atmosphere%2C%20soft%20natural%20composition%2C%20modern%20entertainment%20aesthetic%2C%20clean%20magazine%20photography%20style%20on%20seamless%20warm%20neutral%20background&width=600&height=400&seq=card-thriller-02&orientation=landscape',
  },
  {
    id: 3,
    title: '蓝莓视频 · 古装巨制专题',
    desc: '蓝莓视频精心挑选古装巨制，服化道精良剧情考究，带你穿越千年感受历史风华与家国情怀。',
    tag: '古装',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20film%20inspired%20composition%20with%20dramatic%20warm%20lighting%20contrast%2C%20intense%20mood%2C%20sophisticated%20cinematic%20atmosphere%2C%20modern%20entertainment%20visual%2C%20clean%20editorial%20photography%20on%20seamless%20dark%20warm%20background&width=600&height=400&seq=card-action-03&orientation=landscape',
  },
  {
    id: 4,
    title: '小蓝视频 · 高分电影大全',
    desc: '小蓝视频高分电影一站聚合，从经典到新片全面覆盖，满足电影发烧友的多元观影需求。',
    tag: '电影',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20inspired%20scene%20with%20soft%20rose%20gold%20and%20warm%20amber%20tones%2C%20tender%20emotional%20atmosphere%2C%20elegant%20composition%2C%20modern%20entertainment%20aesthetic%2C%20clean%20fashion%20photography%20style%20on%20seamless%20light%20warm%20background&width=600&height=400&seq=card-romance-04&orientation=landscape',
  },
  {
    id: 5,
    title: '玫瑰视频 · 不缓冲专区',
    desc: '玫瑰视频独家优化播放技术，专为流畅观影打造的不缓冲专区，高清画质秒开秒播不卡顿。',
    tag: '高清',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20inspired%20composition%20with%20moody%20warm%20amber%20lighting%20and%20deep%20shadows%2C%20suspenseful%20atmosphere%2C%20sophisticated%20cinematic%20mood%2C%20modern%20entertainment%20visual%2C%20clean%20dramatic%20photography%20on%20seamless%20dark%20neutral%20background&width=600&height=400&seq=card-mystery-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-3">
            编辑精选
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">精选推荐</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            为你精心挑选的高分影视内容不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.map((card, idx) => (
            <article
              key={card.id}
              className={`group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-background-300/80 transition-all duration-200 cursor-pointer ${
                idx === 3 ? 'sm:col-span-2 lg:col-span-3' : ''
              }`}
            >
              <div className={`flex ${idx === 3 ? 'flex-col md:flex-row' : 'flex-col'}`}>
                <div className={`relative overflow-hidden ${idx === 3 ? 'w-full md:w-1/2 aspect-[16/10] md:aspect-auto md:h-56' : 'aspect-[3/2]'}`}>
                  <img
                    src={card.image}
                    alt={card.title}
                    title={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={idx > 1 ? 'lazy' : undefined}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 rounded-md bg-background-50/90 text-xs font-medium text-primary-700">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className={`p-5 flex flex-col justify-center ${idx === 3 ? 'md:w-1/2' : ''}`}>
                  <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-2">{card.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}